import * as React from 'react'

import APageHeader from '../../components/atoms/APageHeader'
import APageRow from '../../components/atoms/APageRow'
import ReportSettings from '../../containers/admin/ReportSettings'

const PReportSettings = () => (
    <React.Fragment>
        <APageHeader>Report settings</APageHeader>
        <APageRow>
            <ReportSettings />
        </APageRow>
    </React.Fragment>
)

export default PReportSettings
